import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from 'mlb-react-patterns/components';

const Thumbnail = ({
    duration, imageCuts, imageAlt, playing,
}) => {

    const thumbnailClass = classNames({
        'thumbnail': true,
        'thumbnail--playing': playing,
    });

    return (
        <div className={thumbnailClass}>
            <Image
                aspectRatio={'16:9'}
                cuts={imageCuts}
                alt={imageAlt}
            />
            {!playing && <p className={'thumbnail__duration'}>{duration}</p>}
        </div>
    );

};

Thumbnail.propTypes = {
    imageCuts: PropTypes.array.isRequired,
    imageAlt: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    playing: PropTypes.bool,
};

Thumbnail.defaultProps = {
    playing: false,
};

export default Thumbnail;
